import client from './client';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// S3 Bucket Management
export const getS3Buckets = async () => {
  const response = await client.get('/api/s3/buckets');
  return response.data.buckets;
};

export const createS3Bucket = async (bucketData) => {
  const response = await client.post('/api/s3/buckets', bucketData);
  return response.data;
};

export const updateS3Bucket = async (bucketId, bucketData) => {
  const response = await client.put(`/api/s3/buckets/${bucketId}`, bucketData);
  return response.data;
};

export const deleteS3Bucket = async (bucketId) => {
  const response = await client.delete(`/api/s3/buckets/${bucketId}`);
  return response.data;
};

export const getS3Bucket = async (bucketId) => {
  const response = await client.get(`/api/s3/buckets/${bucketId}`);
  return response.data;
};

// S3 Content Management
export const getBucketContents = async (bucketId, prefix = '') => {
  const response = await client.get(`/api/s3/buckets/${bucketId}/contents`, {
    params: { prefix }
  });
  return response.data;
};

export const getBucketFolders = async (bucketId) => {
  const response = await client.get(`/api/s3/buckets/${bucketId}/folders`);
  return response.data;
};

export const uploadToBucket = async (bucketId, folder, files, onProgress) => {
  const formData = new FormData();
  formData.append('folder', folder);
  files.forEach(file => {
    formData.append('files', file);
  });

  // Get token for authenticated upload
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await client.post(
    `/api/s3/buckets/${bucketId}/upload`,
    formData,
    {
      headers,
      onUploadProgress: onProgress,
    }
  );
  return response.data;
};

export const getManifestUrls = async (bucketId, folder) => {
  const response = await client.get(`/api/s3/buckets/${bucketId}/manifest-urls`, {
    params: { folder }
  });
  return response.data;
};

export const deleteContentFolder = async (bucketId, folder) => {
  const response = await client.delete(`/api/s3/buckets/${bucketId}/contents/${folder}`);
  return response.data;
};

// S3 Bucket Import (Discovery + Import)
export const getAwsS3Buckets = async (roleArn = null) => {
  const params = {};
  if (roleArn) {
    params.role_arn = roleArn;
  }
  const response = await client.get('/api/s3/buckets/aws', { params });
  return response.data;
};

export const importS3Bucket = async (importData) => {
  const response = await client.post('/api/s3/buckets/import', importData);
  return response.data;
};
